import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  isBrowser = false;

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private jwtHelper: JwtHelperService,
    private router: Router
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (!this.isBrowser) {
      return false;
    }
    const token = localStorage.getItem('token');
    const isAuthorized = token && !this.jwtHelper.isTokenExpired(token);
    if (isAuthorized) {
      return true;
    }
    this.router.navigate(['login']);
    return true;
  }
}
